import { Select } from "@mantine/core";

export const DropdownSelect = ({
  data,
  label,
  onChange,
  defaultValue,
}: {
  data: { value: string; label: string }[];
  label: string;
  onChange: (value: string | null) => void;
  defaultValue?: string | null;
}) => {
  return (
    <>
      <Select
        label={label}
        data={data}
        searchable
        clearable
        onChange={value => onChange(value)}
        defaultValue={defaultValue}
      />
    </>
  );
};
